import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=266ff06a&scoped=true"
import script from "./Curso.vue?vue&type=script&lang=js"
export * from "./Curso.vue?vue&type=script&lang=js"
import style0 from "./Curso.vue?vue&type=style&index=0&id=266ff06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ff06a",
  null
  
)

export default component.exports